/* shah */
import React from 'react'

const LeftIcon = () => {
    return (
        <svg id="SmallBoxSVG-left" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">
            <metadata>
                Created by potrace 1.16, written by Peter Selinger 2001-2019
            </metadata>
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M578 4690 c-52 -16 -98 -52 -126 -98 -22 -38 -27 -59 -27 -112 0 -85
34 -147 103 -187 l47 -28 1985 0 c1829 0 1987 1 2015 17 80 43 119 108 120
198 0 85 -34 147 -103 187 l-47 28 -1970 2 c-1084 1 -1982 -2 -1997 -7z"/>
                <path d="M578 3410 c-52 -16 -98 -52 -126 -98 -22 -38 -27 -59 -27 -112 0 -85
34 -147 103 -187 l47 -28 1345 0 c1485 0 1367 -5 1434 61 46 46 60 83 61 154
0 85 -34 147 -103 187 l-47 28 -1330 2 c-731 1 -1342 -2 -1357 -7z"/>
                <path d="M578 2130 c-52 -16 -98 -52 -126 -98 -22 -38 -27 -59 -27 -112 0 -85
34 -147 103 -187 l47 -28 1985 0 c1829 0 1987 1 2015 17 80 43 119 108 120
198 0 85 -34 147 -103 187 l-47 28 -1970 2 c-1084 1 -1982 -2 -1997 -7z"/>
                <path d="M578 850 c-52 -16 -98 -52 -126 -98 -22 -38 -27 -59 -27 -112 0 -85
34 -147 103 -187 l47 -28 1345 0 c1485 0 1367 -5 1434 61 46 46 60 83 61 154
0 85 -34 147 -103 187 l-47 28 -1330 2 c-731 1 -1342 -2 -1357 -7z"/>
            </g>
        </svg>
    )
}

export default LeftIcon